export default "/images/cc_payment_options.png";